// src/Component/Vansales/CustomerDetailDrawer.js
import React, { useState, useEffect } from "react";
import {
  Drawer,
  Grid,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  MenuItem,
  Modal,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import axios from "axios";
import { getGlobals } from "../../Configs";
import { useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { fAlertToast } from "../../Utility/Utilitys";

const baseURL = getGlobals().API_BASE_URL;

const CustomerDetailDrawer = ({ open, onClose, rowData, onSaveSuccess }) => {
  const [formData, setFormData] = useState({});
  const [emirates, setEmirates] = useState([]);
  const [imageModal, setImageModal] = useState({ open: false, src: "" });

  const vRdxuserInfo = useSelector((state) => state.login.value);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSave = async (isPost) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      let {
        IsVerified,
        ApDt,
        ApByName,
        EdDt,
        EdByName,
        EnDt,
        EnByName,
        StateName,
        GMLong,
        GMLat,
        GMAddress,
        Salesman,
        Google_Map_Area_ID,
        ...restPayload
      } = formData;
      const payload = {
        ...restPayload,
        UserCd: vRdxuserInfo?.UserID,
        TLExpiry: moment(restPayload.TLExpiry).format("MM/DD/YYYY"),
        TransDt: moment(restPayload.TransDt).format("MM/DD/YYYY"),
        isPost
      };
      // console.log("payload",payload);
      
      const res = await axios.post(
        `${baseURL}CRAppPromotions/SFCustomers_UPDATE`,
        payload
      );
      if (res.data?.Type === "Success") {
        fAlertToast("SUCCESS",isPost ? "Approved successfully" : "Updated successfully");
        onSaveSuccess(); // reload summary list
        onClose();
      }
    } catch (error) {
      console.log(error);
      fAlertToast("FAILED",error?.response?.data?.details || error?.message);
    } finally {
      loader.style.display = "none";
    }
  };

const handleViewImage = async (imageType) => {
  let loader = document?.getElementById("loader");
  try {
    loader.style.display = "flex";
    const res = await axios.post(`${baseURL}CRAppPromotions/SFCustomers_Image_Get`, {
      TransId: formData.TransId,
    });

    if (res?.data && res?.data?.ResultSet) {
      const record = res?.data?.ResultSet[0];
      const base64Str = record?.[imageType];
      if (base64Str) {
        setImageModal({ open: true, src:base64Str });
      } else {
        fAlertToast("FAILED","Image not available.");
      }
    }
  } catch (error) {
    console.error("Image fetch failed", error);
    fAlertToast("FAILED","Failed to fetch image.");
  }finally {
      loader.style.display = "none";
    }
};


    useEffect(() => {
    if (rowData) {
      setFormData({
        ...rowData,
        TransDt: moment(rowData.TransDt).format("YYYY-MM-DD"),
      });
    }
  }, [rowData]);

   useEffect(() => {
    // Load Emirates list on mount
    const fetchEmirates = async () => {
      try {
        const res = await axios.post(`${baseURL}CRAppPromotions/Emirates_List`);
        if (res?.data?.recordset) {
          setEmirates(res.data.recordset);
        }
      } catch (err) {
        console.error("Failed to load emirates", err);
      }
    };
    fetchEmirates();
   },[])

  return (
    <>
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Box p={2} sx={{ width: { xs: 380, sm: 600, md: 800 } }} mt={4}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography variant="h6">Edit Customer Details</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Grid container spacing={{xs:1,sm:1.8}} mt={0.5}>
            <Grid item xs={4} sm={2}>
              <Typography color="primary">Trans Id</Typography>
              <TextField
                fullWidth
                name="TransId"
                value={formData.TransId || ""}
                disabled
                size="small"
              />
            </Grid>
            <Grid item xs={4} sm={2.5}>
              <Typography color="primary">Trans Date</Typography>
              <CmpDatePickerField001V1
                xLabelText=""
                xValue={formData.TransDt || ""}
                xOnChange={(newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    TransDt: newValue.$d,
                  }));
                }}
              />
            </Grid>

            {[
              {
                label: "Customer A/C",
                name: "AcCd",
                readOnly: true,
                gridSize: { xs: 4, sm: 2.5 },
              },
              {
                label: "Customer Name",
                name: "Name",
                readOnly: false,
                gridSize: { xs: 6, sm: 5 },
              },
              {
                label: "Contact Person",
                name: "Contact",
                readOnly: false,
                gridSize: { xs: 6, sm: 4 },
              },
              {
                label: "Contact Email",
                name: "EMail",
                gridSize: { xs: 12, sm: 5 },
              },
              {
                label: "Phone Number",
                name: "Phone",
                readOnly: false,
                gridSize: { xs: 6, sm: 3 },
              },
              {
                label: "Mobile Number",
                name: "Mobile",
                readOnly: false,
                gridSize: { xs: 6, sm: 3 },
              },
              {
                label: "Address 1",
                name: "Addr1",
                readOnly: false,
                gridSize: { xs: 12, sm: 9 },
              },
              {
                label: "Address 2",
                name: "Addr2",
                readOnly: false,
                gridSize: { xs: 12, sm: 6 },
              },
              {
                label: "Address 3",
                name: "Addr3",
                readOnly: false,
                gridSize: { xs: 12, sm: 6 },
              },
              {
                label: "CR Limit",
                name: "CrLimit",
                type: "number",
                readOnly: false,
                gridSize: { xs: 4, sm: 2.5 },
              },
              {
                label: "CR Prd",
                name: "CrPrd",
                type: "number",
                readOnly: false,
                gridSize: { xs: 4, sm: 2.5 },
              },
              {
                label: "TRN No",
                name: "TRNNo",
                readOnly: false,
                gridSize: { xs: 4, sm: 2.5 },
              },
              {
                label: "NameFL",
                name: "NameFL",
                readOnly: false,
                gridSize: { xs: 3.8, sm: 4.5 },
              },
              {
                label: "Lat",
                name: "GMLat",
                readOnly: true,
                gridSize: { xs: 4.1, sm: 2.5 },
              },
              {
                label: "Lng",
                name: "GMLong",
                readOnly: true,
                gridSize: { xs: 4.1, sm: 2.5 },
              },
              {
                label: "Google Map Address",
                name: "GMAddress",
                readOnly: true,
                gridSize: { xs: 6, sm: 7 },
              },
            ].map(({ label, name, type, readOnly, gridSize }) => (
              <Grid item {...gridSize} key={name}>
                <Typography color="primary">{label}</Typography>
                <TextField
                  fullWidth
                  // label={label}
                  name={name}
                  disabled={readOnly}
                  autoComplete="off"
                  type={type || "text"}
                  value={formData[name]}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            ))}

            <Grid item xs={6} sm={4}>
              <Typography color="primary">State</Typography>
              <TextField
                fullWidth
                name="State"
                select
                value={formData.State || ""}
                onChange={handleChange}
                size="small"
              >
                {emirates &&
                  emirates?.length > 0 &&
                  emirates?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label || option.value}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

            <Grid item xs={6} sm={4}>
              <Typography color="primary">Trading License Expiry</Typography>
              <CmpDatePickerField001V1
                xLabelText=""
                xValue={formData.TLExpiry || ""}
                xOnChange={(newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    TLExpiry: newValue.$d,
                  }));
                }}
              />
            </Grid>

              <Grid item xs={6} sm={4} sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.BillToBill == "1"}
                    onChange={handleChange}
                    name="BillToBill"
                  />
                }
                label="Bill To Bill"
              />
            </Grid>

            {/* Image Previews */}
            {[
              { field: "TradeLicence", label: "Trade Licence" },
              { field: "VatRegCert", label: "Vat Registration Certificate" },
            ].map((obj) => (
              <Grid item xs={6} key={obj?.field}>
                <Box
                  border="1px solid gray"
                  height={50}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography color="primary" variant="caption">
                    {obj?.label}
                  </Typography>
                </Box>
                <Button
                  fullWidth
                  size="small"
                  onClick={() => handleViewImage(obj?.field)}
                  variant="contained"
                >
                  View
                </Button>
              </Grid>
            ))}

            <Grid item xs={12} display="flex" justifyContent="flex-end">
              <Stack direction={"row"} gap={2}>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleSave(false)}
                  disabled={formData?.IsVerified}
                >
                  Save
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="success"
                  onClick={() => handleSave(true)}
                  disabled={formData?.IsVerified}
                >
                  Approve
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Drawer>

      {/* Modal for Image View */}
      <Modal
        open={imageModal?.open}
        onClose={() => setImageModal({ open: false, src: "" })}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "transparent", // No background
            p: 0,
            boxShadow: 0,
            borderRadius: 2,
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          {/* Image container with relative position */}
          <Box sx={{ position: "relative", display: "inline-block" }}>
            {/* Download Button */}
            <IconButton
              onClick={() => {
                const link = document.createElement("a");
                link.href = imageModal?.src;
                link.download = "image.png"; // You can dynamically name it
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              sx={{
                position: "absolute",
                top: 8,
                right: 48,
                color: "#fff",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 2,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.7)",
                },
              }}
            >
              <DownloadIcon />
            </IconButton>
            {/* Close icon on image */}
            <IconButton
              onClick={() => setImageModal({ open: false, src: "" })}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "#fff",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 2,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.7)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Preview image */}
            <img
              src={imageModal?.src}
              alt="Preview"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: 4,
                maxWidth: "90vw",
                maxHeight: "90vh",
              }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CustomerDetailDrawer;
